<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/pexels-anna-shvets-3727464.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-subheading weight="800"
            >License to Operate as a Microcredit Institution by the Bank of
            Jamaica</base-subheading
          >
          <base-heading>THE BPO'S CASH RESERVE </base-heading>

          <base-body>
            Welcome to Orenda Financial Services
          </base-body>

          <div
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'flex-column align-start'
                : 'align-center'
            "
            class="d-flex flex-wrap"
          >
            <base-btn to="/account/sign-up"> SIGN UP NOW </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
export default {
  name: "SectionHero",

  provide: {
    theme: { isDark: true },
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
};
</script>
